import {
  CreateShopProductDto,
  ShopProductDto,
  ShopProductReviewDto,
  PatchShopProductDto,
} from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class MarketFrontEndProductActions extends CaEntityActionsFactory<
  ShopProductDto,
  CreateShopProductDto,
  PatchShopProductDto,
  BaseFilterType
> {
  constructor() {
    super(`MarketFrontEndProducts`);
  }

  requestRetrieveProductReviewsAction = createAction(
    `[${this.type}][Request] Retrieve Product Reviews`,
    props<{ productId: string }>(),
  );

  responseFailRetrieveProductReviewsAction = createAction(
    `[${this.type}][Response][Failure] Retrieve Product Reviews`,
    props<{ productId: string; error: any }>(),
  );

  responseSuccessRetrieveProductReviewsAction = createAction(
    `[${this.type}][Response][Success] Retrieve Product Reviews`,
    props<{ productId: string; reviews: ShopProductReviewDto[] }>(),
  );
}

export const MarketFrontEndProducts = new MarketFrontEndProductActions();
